import { ContractParameterBase } from './ContractParameterBase';
import { ContractParameterType } from './ContractParameterType';
export class InteropInterfaceContractParameter extends ContractParameterBase {
    constructor() {
        super(...arguments);
        this.type = ContractParameterType.InteropInterface;
        this.size = 0;
    }
    static deserializeWireBase(options) {
        super.deserializeContractParameterBaseWireBase(options);
        return new this();
    }
    serializeJSON(_context) {
        return {
            type: 'InteropInterface',
        };
    }
}

//# sourceMappingURL=InteropInterfaceContractParameter.js.map
